import api from "../api";

export const searchUsers = async (query, filters = {}) => {
  return await api.getApi().get("/users/search", {
    params: { q: query, ...filters },
  });
};

export const discoverUsers = async () => {
  return await api.getApi().get("/users/discover");
};

export const followUser = async (userId) => {
  return await api.getApi().post(`/users/${userId}/follow`);
};

export const unfollowUser = async (userId) => {
  return await api.getApi().delete(`/users/${userId}/unfollow`);
};

export const getFollowers = async (userId) => {
  return await api.getApi().get(`/users/${userId}/followers`);
};

export const getFollowing = async (userId) => {
  return await api.getApi().get(`/users/${userId}/following`);
};

export const checkFollowStatus = async (userId) => {
  return await api.getApi().get(`/users/${userId}/follow-status`);
};
